import { Languages } from 'config';

const CONFIGURATION = {};

export default CONFIGURATION;

export const Translations = {
  add: {
    [Languages.Greek]: 'Add VAT return',
    [Languages.English]: 'Add VAT return',
  },
  type_control: {
    [Languages.Greek]: 'Scheme Type',
    [Languages.English]: 'Scheme Type',
  },
  vat_num_control: {
    [Languages.Greek]: 'VAT Number',
    [Languages.English]: 'VAT Number',
  },
  period_control: {
    [Languages.Greek]: 'Period',
    [Languages.English]: 'Period',
  },
  year_control: {
    [Languages.Greek]: 'Year',
    [Languages.English]: 'Year',
  },
  note1: {
    [Languages.Greek]:
      'Please fill the below fields only if you have changed Member State of Identification within the reporting period.',
    [Languages.English]:
      'Please fill the below fields only if you have changed Member State of Identification within the reporting period.',
  },
  note2: {
    [Languages.Greek]:
      'In this case you should fill two OSS VAT returns, one from the beginning of the period till the date of change in identification (to the originating Member state) and one from the date of change in identification till the end of the reporting period (to the Member state of Destination).',
    [Languages.English]:
      'In this case you should fill two OSS VAT returns, one from the beginning of the period till the date of change in identification (to the originating Member state) and one from the date of change in identification till the end of the reporting period (to the Member state of Destination).',
  },
  start_date_control: {
    [Languages.Greek]: 'Start Date',
    [Languages.English]: 'Start Date',
  },
  end_date_control: {
    [Languages.Greek]: 'End Date',
    [Languages.English]: 'End Date',
  },
  active_registration_error: {
    [Languages.Greek]:
      'You should have at least one active registration to be able to create a VAT Return.',
    [Languages.English]:
      'You should have at least one active registration to be able to create a VAT Return.',
  },
};
